import {Component, EventEmitter, Inject, Input} from '@angular/core';
import {HelpModel} from '@spout/global-web/models';
import {Observable, Subject} from 'rxjs';
import {CONTAINER_DATA, ContentModel} from '../content.model';

@Component({
  selector: 'spt-help-compressor',
  templateUrl: './help-compressor.component.html',
  styleUrls: ['./help-compressor.component.scss']
})
export class HelpCompressorComponent implements ContentModel {
  static ref = HelpModel.COMPRESSOR;
  static title = 'Compressor Settings';

  showBackHeader = true;

  helpTitle = HelpCompressorComponent.title;

  private modalClose: Subject<any> = new Subject();

  onModalClose(): Observable<any> {
    return this.modalClose.asObservable();
  }

  constructor(@Inject(CONTAINER_DATA) private data: ContentModel) {
    if (this.data) {
      this.showBackHeader = this.data.showBackHeader;
    }
  }

  closeModal() {
    this.modalClose.next(null);
    this.modalClose.complete();
  }
}
